import { render } from "./teacherlist.vue?vue&type=template&id=2b2208fc"
import script from "./teacherlist.vue?vue&type=script&lang=js"
export * from "./teacherlist.vue?vue&type=script&lang=js"

import "./teacherlist.vue?vue&type=style&index=0&id=2b2208fc&lang=css"
script.render = render

export default script